import dynamic from 'next/dynamic';
import TheHelmet from '../components/TheHelmet';
import config from '../config';

const PageProfile = dynamic(() => import('../components/PageProfile'), {
  ssr: false,
});

export default function Home() {
  return (
    <div>
      <TheHelmet title={`Wallet - ${config.siteName}`} description={config.description} />
      <PageProfile />
    </div>
  );
}
